
import { formatCurrency } from '@/lib/utils';

interface PayslipSummaryProps {
  grossPayYTD?: number;
  taxMonthly?: number;
  taxYTD?: number;
  napsaMonthly?: number;
  lasfMonthly?: number;
  napsaYTD?: number;
  lasfYTD?: number;
  pspfYTD?: number;
  openingLeaveDays?: number;
  closingLeaveDays?: number;
  closingLeaveDaysValue?: number;
  advanceCF?: number;
  advanceBF?: number;
}

export const PayslipSummary = ({
  grossPayYTD,
  taxMonthly,
  taxYTD,
  napsaMonthly,
  lasfMonthly,
  napsaYTD,
  lasfYTD,
  pspfYTD,
  openingLeaveDays,
  closingLeaveDays,
  closingLeaveDaysValue,
  advanceCF,
  advanceBF,
}: PayslipSummaryProps) => {
  return (
    <div className="p-6 border b border-gray-400 rounded-md">
      <h3 className="font-semibold text-lg mb-3">Summary</h3>
      <div className="grid grid-cols-2 gap-x-4 gap-y-2">
        <div className="flex justify-between">
          <span>Gross Pay YTD</span>
          <span className="font-medium">{grossPayYTD ? formatCurrency(grossPayYTD) : 'N/A'}</span>
        </div>
        <div className="flex justify-between">
          <span>Monthly Tax</span>
          <span className="font-medium">{taxMonthly ? formatCurrency(taxMonthly) : 'N/A'}</span>
        </div>
        <div className="flex justify-between">
          <span>Tax YTD</span>
          <span className="font-medium">{taxYTD ? formatCurrency(taxYTD) : 'N/A'}</span>
        </div>
        <div className="flex justify-between">
          <span>Monthly NAPSA</span>
          <span className="font-medium">{napsaMonthly ? formatCurrency(napsaMonthly) : 'N/A'}</span>
        </div>
        <div className="flex justify-between">
          <span>Monthly LASF</span>
          <span className="font-medium">{lasfMonthly ? formatCurrency(lasfMonthly || 0) : '-'}</span>
        </div>
        <div className="flex justify-between">
          <span>NAPSA YTD</span>
          <span className="font-medium">{napsaYTD ? formatCurrency(napsaYTD) : 'N/A'}</span>
        </div>
        <div className="flex justify-between">
          <span>LASF YTD</span>
          <span className="font-medium">{lasfYTD ? formatCurrency(lasfYTD || 0) : '-'}</span>
        </div>
        <div className="flex justify-between">
          <span>PSPF YTD</span>
          <span className="font-medium">{pspfYTD ? formatCurrency(pspfYTD || 0) : '-'}</span>
        </div>
        <div className="flex justify-between">
          <span>Leave Opening</span>
          <span className="font-medium">
            {openingLeaveDays != null
              ? `${Number(openingLeaveDays).toFixed(1)} days`
              : 'N/A'}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Leave Balance</span>
          <span className="font-medium">
            {closingLeaveDays != null && closingLeaveDays !== undefined
              ? `${Number(closingLeaveDays).toFixed(1)} days`
              : 'N/A'}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Leave Balance (ZMK)</span>
          <span className="font-medium">
            {closingLeaveDaysValue != null && closingLeaveDaysValue !== undefined
              ? formatCurrency(closingLeaveDaysValue)
              : 'N/A'}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Advance B/F</span>
          <span className="font-medium">
            {advanceBF != null && advanceBF !== undefined ? formatCurrency(advanceBF) : '-'}
          </span>
        </div>
        <div className="flex justify-between">
          <span>Advance C/F</span>
          <span className="font-medium">
            {advanceCF != null && advanceCF !== undefined ? formatCurrency(advanceCF) : '-'}
          </span>
        </div>
      </div>
    </div>
  );
};
